import React from "react";
import { useSelector } from "react-redux";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";
import styles from "./dashBoardStyles.module.css";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const Performance = () => {
  const data = useSelector((state) => state.dashboard.data);
  const performanceData = {
    data: {
      labels: Object.keys(data.performance),
      datasets: [
        {
          axis: "y",
          label: "# of Hits",
          data: Object.values(data.performance),
          fill: false,
          backgroundColor: Object.keys(data.performance),
          borderColor: Object.keys(data.performance),
          borderWidth: 1,
        },
      ],
    },
  };
  return (
    <section className={styles.performanceSection}>
      <h1>Performance</h1>
      <div style={{ width: "90%", height: "80%" }}>
        <Bar
          options={{ indexAxis: "y", responsive: true,maintainAspectRatio:false,color:"white"}}
          data={performanceData.data}
        />
      </div>
    </section>
  );
};

export default Performance;
